export default __webpack_public_path__ + "static/media/kiwi_black.bc27f251.png";